import unableToSaveDialogTemplate from './unable-to-save-dialog.tpl.html';
import './unable-to-save-dialog.less';
import { modalComponentModule } from '../../../../shared/app/components/modal/modal';
import { formDataServiceModule } from '../../../../shared/app/services/form-data-service/form-data-service';
import { onConfirmComponentModule } from '../../../../shared/app/components/on-confirm/on-confirm';
import {
  ERROR_CONTEXT,
  messageHubServiceModule,
} from '../../services/message-hub-service/message-hub-service';

export const unableToSaveDialogComponentModule = angular
  .module('Q.components.unable-to-save-dialog', [
    modalComponentModule,
    formDataServiceModule,
    onConfirmComponentModule,
    messageHubServiceModule,
  ])

  .factory('unableToSaveDialog', function ($modal) {
    return {
      open(attempts, saveFn, resp) {
        const dialog = $modal.openOnce('unableToSaveDialog', {
          template: unableToSaveDialogTemplate,
          controller: 'UnableToSaveDialogCtrl as $ctrl',
          backdrop: 'static',
          windowClass: 'unable-to-save-dialog',
          keyboard: false,
          resolve: {
            attempts: () => attempts,
            saveFn: () => saveFn,
            resp: () => resp,
          },
        });

        return dialog.result;
      },
    };
  })

  .controller(
    'UnableToSaveDialogCtrl',
    function UnableToSaveDialogCtrl(
      $modalInstance,
      attempts,
      saveFn,
      resp,
      appAlert,
      formDataService,
      $window,
      messageHubService,
    ) {
      const ctrl = this;
      ctrl.attempts = attempts;

      ctrl.error = resp && appAlert.modelErrorMessage(resp);

      const notifyError = () => {
        messageHubService.postError(ERROR_CONTEXT.saveSolution, {
          message: 'Unable to save solution',
          attempts: ctrl.attempts,
        });
      };
      notifyError();

      ctrl.tryAgain = () => {
        ctrl.saving = true;
        ctrl.tryAgainFailed = false;
        saveFn()
          .then(() => {
            $modalInstance.dismiss();
          })
          .catch((resp) => {
            ctrl.error = resp && appAlert.modelErrorMessage(resp);
            ctrl.tryAgainFailed = true;
            ctrl.attempts++;
            notifyError();
          })
          .finally(() => {
            ctrl.saving = false;
          });
      };

      ctrl.reload = (trashEdits) => {
        ctrl.saving = true;
        if (trashEdits) {
          formDataService.reset();
        }
        $window.location.reload(true);
      };
    },
  );
